module.exports = __webpack_public_path__ + "frame-59ed99bf/anschreiben-logo-light-ea99b3735f684cd56735a43a096cf39c.svg";